// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__360Aa","actions":"GroupTable_actions__23K8k","deleteModalFooter":"GroupTable_deleteModalFooter__26i2P"};